/* ------------------------------------------------------------------
   File: LeadershipBoard.jsx
   Author: Engr. Shaffa K. Kokro Jr. - CEO, Accend Holdings Ltd.
   Last Modified: 2026-01-07
------------------------------------------------------------------ */

import React from "react";
// import HeroBannerSection from "../../sections/Global/HeroBannerSection";
// import PageBreadcrumbs from "../../sections/Global/PageBreadcrumbs";
// import LBSection1 from "../../sections/LeadershipBoard/LBSection1";
// import LBSection2 from "../../sections/LeadershipBoard/LBSection2";
// import LBSection3 from "../../sections/LeadershipBoard/LBSection3";
// import LBSection4 from "../../sections/LeadershipBoard/LBSection4";

function Leadership() {
  return (
    <div id="pageLeadershipBoard" className="__page">
      {/* <HeroBannerSection
        title="Our Leadership"
        subtext="The people shaping Accend's strategy, culture, and long-term direction — 
          experienced builders, investors, and operators devoted to enterprise excellence 
          across African markets."
      />
      <PageBreadcrumbs
        page="Leadership"
        dir="About Us"
      />
      <LBSection1 />
      <LBSection2 /> */}

      Leadership page
      
    </div>
  );
}

export default Leadership;
